/**
 * Single source of truth for product identity.
 * Renaming the app means changing this file and nothing else.
 */

export const APP_NAME = 'Slipway' as const;

/** Folder under %USERPROFILE% where incoming files land on Windows. */
export const DROP_FOLDER_NAME = APP_NAME;

/** Tagline used on the pairing screen and the App Store listing. */
export const TAGLINE = 'Your iPhone and your PC, finally connected.' as const;

/**
 * Largest payload we store inline in D1 rather than as an R2 blob.
 * Inline items skip the object-store round trip entirely, which is what
 * makes phone -> PC clipboard feel instant.
 */
export const INLINE_MAX_BYTES = 32_768 as const;

/** Presigned R2 URL lifetime. Short: they are minted on demand. */
export const PRESIGN_TTL_SECONDS = 15 * 60;

/** Access-token lifetime. Refresh tokens rotate on use. */
export const ACCESS_TTL_SECONDS = 15 * 60;

/** How long a pairing code stays valid before it must be regenerated. */
export const PAIRING_TTL_SECONDS = 5 * 60;

/** Free-plan retention. Pro keeps everything (expires_at = NULL). */
export const FREE_RETENTION_DAYS = 7;

/** Uploads above this use R2 multipart rather than a single PUT. */
export const MULTIPART_THRESHOLD_BYTES = 100 * 1024 * 1024;
